var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-heading"},[_vm._v("\n            "+_vm._s(_vm.trans_heading)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('plot',{ref:_vm.plotId,attrs:{"id":_vm.plotId,"options":_vm.options,"type":_vm.type}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }